import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import {
  useLoadScript,
  GoogleMap,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { setStateParams } from "../Redux/Actions/webAppActions";
//import { REACT_APP_GOOGLE_MAPS_API_KEY } from "../Utils/StaticData/Constant";
// import "../../assets/css/spinner.css";
const containerStyle = {
  width: "100%",
  height: "100%",
};
const icons = {
  primary: {
    icon: "https://img.icons8.com/flat-round/30/undefined/home--v1.png",
  },
  pcp: {
    icon: "https://img.icons8.com/external-justicon-flat-justicon/40/undefined/external-doctor-hospital-and-medical-justicon-flat-justicon.png", //"https://img.icons8.com/color/30/undefined/doctor-male-skin-type-1.png",
  },
  selected: {
    icon: "https://img.icons8.com/external-konkapp-outline-color-konkapp/40/undefined/external-doctor-medical-konkapp-outline-color-konkapp.png", // "https://img.icons8.com/plasticine/30/undefined/hospital-3.png",
  },
};
const Map = (props) => {
  const [selectedPCP, setSelectedPCP] = useState(null);
  // const [center, setCenter] = useState({});
  const [primaryAddress, setPrimaryAddress] = useState(null);
  const [preSelectedPCP, setPreSelectedPCP] = useState({});
  const [key, setKey] = useState(0);
  //const [newPcps,setNewPcps] = useState([])
  const {pcpApiKey} = useSelector((state)=>state.login)
  const options = useMemo(
    () => ({
      // disableDefaultUI: true,
      clickableIcons: false,
    }),
    []
  );
  useEffect(() => {
    setKey(key + 1);
  }, []);
  const mapRef = useRef();

  // const onLoad =
  useCallback((map) => (mapRef.current = map), []);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: pcpApiKey,
  });

  const handlePCP = (e, pcp) => {
    let newPCPs = [...props.pcps];
    let newPCPs1 = [];
    if (pcp) {
      props.setResetFlag();
      let selectedIndex = newPCPs.indexOf(pcp);
      props.setStateParams("selectedIndex", selectedIndex);
      newPCPs1 = newPCPs.map((newPcp) => {
        return { ...newPcp, selected: false, choosen: false };
      });
      newPCPs1[selectedIndex] = {
        ...newPCPs[selectedIndex],
        selected: true,
        choosen: true,
      };
      setSelectedPCP(pcp);
      props.handlePCPList(newPCPs1);
      props.handlePCP(pcp);
      setPreSelectedPCP({ ...preSelectedPCP, selected: false });
    } else {
      newPCPs1 = newPCPs.map((pcp1) => {
        return { ...pcp1, selected: false, choosen: false };
      });
      props.handlePCPList(newPCPs1);
      props.handlePCP(null);
      setPreSelectedPCP({ ...preSelectedPCP, selected: true });
    }
  };

  const infoWindoClose = () => {
    //console.log("clicked")
    let tempPCPs1 = props.pcps;
    let updatedPCPs = [];
    if (tempPCPs1) {
      updatedPCPs = tempPCPs1.map((pcp1) => {
        return { ...pcp1, selected: false };
      });
    }

    //setPcps(updatedPCPs);
    props.handlePCPList(updatedPCPs);
    setSelectedPCP(null);
  };
  useEffect(() => {
    // console.log(props.primaryAddress)
    // const center = {
    //   lat: props.primaryAddress?.lat,
    //   lng: props.primaryAddress?.lng,
    // };
    // console.log(center)
    // setCenter(props.primaryAddress);
    setPrimaryAddress(props.primaryAddress);
  }, [props.primaryAddress, props.mapKey]);

  useEffect(() => {
    setPreSelectedPCP(props.preSelectedPCP);
  }, [props.preSelectedPCP]);
  // console.log("zz-",{lat:parseFloat(props.primaryAddress.lat),lng:parseFloat(props.primaryAddress.lng)})
  let cnt = {
    lat: parseFloat(props.primaryAddress.lat),
    lng: parseFloat(props.primaryAddress.lng),
  };
  //   useEffect(() => {
  //     console.log(props.preEnrollInfo)
  //     console.log(props.pcpList)
  //     const newArr = props.pcpList.map(pcp => {
  //   if (pcp.latitude === props.preEnrollInfo.pcpDetails.lat ) {
  //     console.log(pcp)
  //     return {...pcp,selected:true};

  //   }
  //   return pcp;
  // });
  // const filtered=newArr.filter(item => item.selected === true);
  // console.log(filtered[0])
  // setPreSelectedPCP(filtered[0])
  // setNewPcps(newArr)
  // console.log(newArr)
  //   }, [])

  //console.log(newPcps)
  //console.log(props.loadPcp.latlng?parseFloat(props.loadPcp.latlng.lat):props.loadPcp.latlng)

  if (!isLoaded) return <div id="cover-spin"></div>;
  return (
    <div class="map-set-heightwidth">
      {/* {props.PCPs.length > 0 ? ( */}
      <GoogleMap
        zoom={6}
        center={cnt}
        mapContainerStyle={containerStyle}
        options={options}
        // onLoad={onLoad}
        // onLoad={map => {
        //   const bounds = new window.google.maps.LatLngBounds();
        //   map.fitBounds(bounds);
        // }}
        onClick={() => {
          infoWindoClose();
        }}
      >
        <>
          <Marker
            key={primaryAddress?.lat}
            position={{
              lat: primaryAddress?.lat,
              lng: primaryAddress?.lng,
            }}
            icon={icons["primary"].icon}
          ></Marker>

          {preSelectedPCP?.latlng?.lat && (
            <Marker
              key={preSelectedPCP.latlng?.lat}
              position={{
                lat: preSelectedPCP.latlng?.lat,
                lng: preSelectedPCP.latlng?.lng,
              }}
              icon={
                preSelectedPCP?.selected
                  ? icons["selected"].icon
                  : icons["pcp"].icon
              }
              onClick={(e) => {
                handlePCP(e);
              }}
            ></Marker>
          )}
          {/* {props.loadPcp?.latlng?.lat && (
            <Marker
              key={props.loadPcp.latlng?.lat}
              position={{
                lat: parseFloat(props.loadPcp.latlng?.lat),
                lng: parseFloat(props.loadPcp.latlng?.lng),
              }}
              icon={
                props.loadPcp?.selected
                  ? icons["selected"].icon
                  : icons["pcp"].icon
              }
              onClick={(e) => {
                handlePCP(e);
              }}
            ></Marker>
          )}      */}
          {props.pcps?.map((pcp) => (
            <Marker
              key={pcp?.latitude}
              position={{
                lat: parseFloat(pcp?.latitude),
                lng: parseFloat(pcp?.longitude),
              }}
              onClick={(e) => {
                handlePCP(e, pcp);
              }}
              icon={pcp.choosen ? icons["selected"].icon : icons["pcp"].icon}
            >
              {pcp?.selected === true && selectedPCP !== null && (
                <InfoWindow
                  position={{
                    lat: parseFloat(pcp?.latitude),
                    lng: parseFloat(pcp?.longitude),
                  }}
                  onCloseClick={() => {
                    infoWindoClose();
                  }}
                >
                  <div className="map-popup-aligner accept-new-patient">
                    <h6>{selectedPCP?.doctorName}</h6>
                    <p>
                      Accept New Patient :{" "}
                      {selectedPCP?.acceptNewPatient === "Y" ? "Yes" : "No"}
                    </p>
                    <p>Provider code : {selectedPCP?.providerCode ?? ""}</p>
                    <p>
                      {selectedPCP?.doctorAddress}, {selectedPCP?.city},
                      {selectedPCP?.stateCode}-{selectedPCP?.zipCode}
                    </p>
                    <p>Distance: {selectedPCP?.googleApiDistance} mi</p>
                  </div>
                </InfoWindow>
              )}
            </Marker>
          ))}
        </>
        {/* ) : null} */}
      </GoogleMap>
      {/* ) : null} */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    preEnrollInfo: state.webApp.preEnrollInfo,
  };
};
const mapDispatchToProps = {
  setStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(Map);
